import React from 'react';

import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import PencilIcon from 'material-ui/svg-icons/image/edit';

function EditMenu(props) {
  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      <IconButton
        aria-label="Edit"
        onTouchTap={props.handleEdit}
      >
        <PencilIcon color="#555" />
      </IconButton>
      <IconButton
        aria-label="Remove"
        onTouchTap={props.handleRemove}
      >
        <DeleteIcon color="#555" />
      </IconButton>
      {props.handleMergeRequest &&
        <IconMenu
          iconButtonElement={<IconButton><NavigationMoreVert /></IconButton>}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          >
            <IconButton
            primaryText="Merge"
            onTouchTap={props.handleMergeRequest}
            />
          }
          <MenuItem
            primaryText="Cancel"
            onTouchTap={null}
            />
        </IconMenu>
      }
    </div>
  );
}

export default EditMenu;



/** WEBPACK FOOTER **
 ** ./components/EditMenu.js
 **/